import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

const DEPARTMENT_MIN_WIDTH = '192px';
const DEPARTMENT_MAX_WIDTH = '270px';

export const StyledSliderWrapper = styled(Box)`
  ${themeMediaQuery('sm')} {
    padding-top: ${themeSpace(3)};
  }
  ${themeMediaQuery('below_sm')} {
    .react-horizontal-scrolling-menu--scroll-container {
      padding: 0;
    }
    .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar-track {
      margin: 0;
    }
  }
`;

export const Vendors = styled(Box)``;

export const StyledText = styled(Text)`
  font-size: 20px;
  line-height: 32px;
  ${themeMediaQuery('below_sm')} {
    font-size: 17px;
    line-height: 27px;
    max-width: 195px;
    text-align: center;
    margin: auto;
  }
`;

export const StyledBox = styled(Box)`
  ${themeMediaQuery('xl')} {
    margin-top: ${themeSpace(9)};
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  border-radius: ${themeSpace(3)};
  transition: transform 0.8s ease;
  ${themeMediaQuery('below_sm')} {
    height: 216px;
    width: 192px;
  }
`;

export const Department = styled(Flex)`
  max-width: ${DEPARTMENT_MAX_WIDTH};
  min-width: ${DEPARTMENT_MIN_WIDTH};
  align-items: baseline;
  border-radius: ${themeSpace(3)};
  position: relative;
  overflow: hidden;
  transition: transform 0.5s ease;

  &:hover {
    transform: scale(1.05);
    ${StyledCloudImage} {
      transform: scale(1.15);
    }
  }

  ${themeMediaQuery('below_sm')} {
    width: 193px;
  }
`;

export const Overlay = styled(Box)`
  z-index: 1;
  position: absolute;
  left: 50%;
  width: max-content;
  bottom: ${themeSpace(6)};
  transform: translate(-50%, 0px);
`;

export const DepartmentText = styled(Text)``;
